import React from "react";
import { Alert, Button, LinearProgress, Paper, Stack, Typography } from "@mui/material";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import ShippingCostGroupList from "./ShippingCostGroupList";
import ShippingCostSkeletonGrid from "./ShippingCostSkeletonGrid";

const ShippingCostContent = ({ loading, error, hasResults, groups, onCreate, onEdit, onDelete }) => (
    <Stack spacing={3}>
        {loading && <LinearProgress />}

        {!loading && error && <Alert severity="error">{error}</Alert>}

        {!loading && !error && !hasResults ? (
            <Paper
                variant="outlined"
                sx={{ p: { xs: 3, md: 6 }, borderRadius: 4, textAlign: "center" }}
            >
                <Typography variant="h6" sx={{ fontWeight: 800 }}>
                    Noch keine Versandkosten vorhanden
                </Typography>
                <Typography sx={{ mt: 1.5, opacity: 0.8 }}>
                    Lege deine erste Versandpauschale mit Nettopreis an.
                </Typography>
                <Button
                    variant="contained"
                    startIcon={<AddRoundedIcon />}
                    onClick={onCreate}
                    sx={{
                        mt: 3,
                        backgroundColor: "orange",
                        color: "#000",
                        fontWeight: 700,
                        "&:hover": { backgroundColor: "#ff9e1a" },
                    }}
                >
                    Versandkosten hinzufügen
                </Button>
            </Paper>
        ) : (
            <>
                {!loading && !error && hasResults && (
                    <ShippingCostGroupList groups={groups} onEdit={onEdit} onDelete={onDelete} />
                )}
                {loading && <ShippingCostSkeletonGrid />}
            </>
        )}
    </Stack>
);

export default ShippingCostContent;
